import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SnackbarService, SnackbarState } from './snackbar.service';

@Component({
  selector: 'app-snackbar-container',
  templateUrl: './snackbar-container.component.html',
  styleUrls: ['./snackbar-container.component.scss'],
  host: {
    '[class]': '"snackbar-overlay"',
    '[class.snackbar-overlay--visible]': '!!state',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarContainerComponent implements OnInit, OnDestroy {
  state: SnackbarState | null = null;

  private readonly destroy$ = new Subject<void>();

  constructor(
    private snackbarService: SnackbarService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.snackbarService.snackbar$
      .pipe(takeUntil(this.destroy$))
      .subscribe((state) => {
        this.state = state;
        this.cdr.markForCheck();
      });
  }

  get containerClasses(): string {
    const classes = ['snackbar'];

    if (this.state?.config?.state) {
      classes.push(`snackbar--${this.state.config.state}`);
    }

    return classes.join(' ');
  }

  onAction(): void {
    this.state?.ref?.dismissWithAction();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
